export default __webpack_public_path__ + "static/media/GreenCheck.6f8d0c66.svg";